import React, { Suspense } from 'react'; // Ajout de Suspense si vous utilisez React.lazy
import { Routes, Route } from 'react-router-dom';

// Utilisation de React.lazy pour les pages pour le code splitting
const Accueil = React.lazy(() => import('./pages/Accueil/Accueil'));
const ServicesPage = React.lazy(() => import('./pages/ServicesPage/ServicesPage'));
const Tarifs = React.lazy(() => import('./pages/Tarifs/Tarifs'));
const Contact = React.lazy(() => import('./pages/Contact/Contact'));
const MentionsLegales = React.lazy(() => import('./pages/MentionsLegales/MentionsLegales')); // NOUVELLE PAGE
const Jeux = React.lazy(() => import('./pages/Jeux/Jeux')); // <-- NOUVELLE PAGE JEUX

function AppRouter() {
  return (
    <Suspense fallback={<div className="container page-section"><p>Chargement de la page...</p></div>}>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/tarifs" element={<Tarifs />} />
        <Route path="/jeux" element={<Jeux />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} /> {/* ROUTE AJOUTÉE */}
      </Routes>
    </Suspense>
  );
}

export default AppRouter;